import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { NavBar, Toast, Form, Field, Button, Selector, Tag, Space } from 'react-vant';
import { ArrowLeft } from '@react-vant/icons';
import { getClubDetail, updateClub, createClub } from '../../../api/club';

const AdminClubEdit = () => {
  const { clubId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const isNew = clubId === 'new';
  const [loading, setLoading] = useState(!isNew);

  const categories = [
    { label: '球类', value: '球类' },
    { label: '田径', value: '田径' },
    { label: '艺术', value: '艺术' },
    { label: '科技', value: '科技' },
    { label: '棋类', value: '棋类' },
    { label: '其他', value: '其他' },
  ];

  const grades = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一', '初二', '初三', '高一', '高二', '高三'];

  useEffect(() => {
    if (!isNew) {
      fetchDetail();
    }
  }, [clubId]);

  const fetchDetail = async () => {
    try {
      const res = await getClubDetail(clubId);
      form.setFieldsValue({
        ...res,
        grade_range: res.grade_range || []
      });
    } catch (error) {
      Toast.fail('获取详情失败');
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      if (isNew) {
        await createClub(values);
        Toast.success('创建成功');
      } else {
        await updateClub(clubId, values);
        Toast.success('更新成功');
      }
      setTimeout(() => navigate(-1), 1500);
    } catch (error) {
      Toast.fail('操作失败');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <NavBar 
        title={isNew ? '创建社团' : '编辑社团'} 
        leftText={<ArrowLeft size={20} />} 
        onClickLeft={() => navigate(-1)}
        fixed
        placeholder
      />

      <div style={{ padding: '16px' }}>
        <Form
          form={form}
          onFinish={onFinish}
          layout='vertical'
          footer={
            <div style={{ margin: '16px 0' }}>
              <Button nativeType='submit' type='primary' block round>
                保存
              </Button>
            </div>
          }
        >
          <div style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', padding: '0 12px' }}>
            <Form.Item
              label='社团名称'
              name='name'
              rules={[{ required: true, message: '请输入社团名称' }]}
            >
              <Field placeholder='请输入名称' />
            </Form.Item>

            <Form.Item
              label='社团分类'
              name='category'
              rules={[{ required: true, message: '请选择分类' }]}
            >
              <Selector
                options={categories}
                style={{ '--rv-selector-border-radius': '8px' }}
              />
            </Form.Item>

            <Form.Item
              label='指导教师姓名'
              name='instructor_name'
              rules={[{ required: true, message: '请输入教师姓名' }]}
            >
              <Field placeholder='请输入教师姓名' />
            </Form.Item>

            <Form.Item
              label='上课地点'
              name='venue'
            >
              <Field placeholder='请输入上课地点' />
            </Form.Item>

            <Form.Item
              label='允许报名年级'
              name='grade_range'
            >
              <Selector
                multiple
                options={grades.map(g => ({ label: g, value: g }))}
                style={{ '--rv-selector-border-radius': '8px' }}
              />
            </Form.Item>

            <Form.Item
              label='状态'
              name='status'
              initialValue='active'
            >
              <Selector
                options={[
                  { label: '激活', value: 'active' },
                  { label: '停用', value: 'inactive' },
                ]}
                style={{ '--rv-selector-border-radius': '8px' }}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AdminClubEdit;
